import { tenantBillingControllerPayPaymentNow } from '@/generated/korza-api-client';

export async function payTenantPayment(
  tenantSlug: string,
  paymentId: string
): Promise<void> {
  await tenantBillingControllerPayPaymentNow({
    path: { tenantSlug, id: paymentId },
    body: {},
    throwOnError: true,
  });
}
